import React, { useState, Fragment } from "react";
import { Table, Label } from "reactstrap";
import { useSelector } from "react-redux";
import style from "./OrdersComponent.scss";
import pdf from "../../../../public/svg/downloadPdf.svg";
import { Warning } from "../../Warning/Warning";
import { getOrders } from "../../../services/api/inout";
import { fetchInProcesOrderPDF } from "../../../services/api/accounts";
import { useEffect } from "react";
import { getCurrentAccount, getTexts } from "../../../reducers/selectors";
import { showToast } from "../../../utils/helper";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { Container } from "../../UI/Container/Container";
import { Col, Row } from "../../UI/Customstrap/Customstrap";
import moment from "moment";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

const OrdersComponent = () => {
  const currentAccount = useSelector(getCurrentAccount);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const texts = useSelector(getTexts);

  useEffect(() => {
    setLoading(() => true);
    if (currentAccount) {
      if (currentAccount.AccountNumber && currentAccount.accountNumber !== 0) {
        getOrders({ accountNumber: currentAccount.AccountNumber })
          .then(({ response }) => {
            setOrders(response.orders);
          })
          .catch((err) => {
            console.error(err);
            showToast("Error obteniendo ordenes en proceso", true);
          })
          .finally(() => {
            setLoading(() => false);
          });
      }
    }
  }, [currentAccount]);

  const handleDownload = (item) => {
    setLoading(() => true);
    fetchInProcesOrderPDF({
      orderId: item.OrderId,
      accountId: currentAccount.id,
    })
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo pdf del servidor", true);
        } else {
          var a = document.createElement("A");
          a.href = `data:application/octet-stream;base64,${response.blobfile}`;
          a.download = `${moment(item.OrderInitDate).format("DD-MM-YY")}-${item.OrderId}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(() => false);
      });
  };

  if (loading) return <CircularProgress />;

  const EmptyTable = () => {
    return <div className={style.message}>No hay órdenes disponibles.</div>;
  };

  if (loading) return <CircularProgress />;

  return (
    <Fragment>
      <Row className={style.headerTitle}>
        <Label>Órdenes en proceso</Label>
      </Row>
      <Row>
        <Col className={style.activityTable} lg="12">
          <Container className={style.containerTable}>
            {orders.length === 0 ? (
              <EmptyTable />
            ) : (
              <div className={style.tableScroll}>
                <Table className={style.table}>
                  <thead className={style.tableHead}>
                    <tr className={style.tableRow}>
                      <th className={`${style.tableH}`}>Fecha</th>
                      <th className={`${style.tableH} `}>Producto</th>
                      <th className={`${style.tableH} `}>Tipo</th>
                      <th className={`${style.tableH}`}>Instrumento</th>
                      <th className={style.tableH}>Monto total a operar</th>
                      <th className={style.tableH}>Moneda</th>
                      <th className={style.tableH}>{"   "}</th>
                    </tr>
                  </thead>
                  <tbody className={style.tableBody}>
                    {orders.map((item, index) => {
                      let description = "";
                      let ammountString = "";
                      let ammount = 0;
                      let currency = "";

                      const formString = {
                        Bonds: "Bonos",
                        Equity: "Acciones",
                        Options: "Opciones",
                        "Mutual Funds": "Fondos Mutuos",
                        "Money Market": "Money Market",
                        Forex: "Forex",
                        Repo: "Repos",
                        Future: "Futuros",
                      };

                      description += `${item.AssetTicker.trim()} - ${item.AssetDescription.trim()} `;

                      switch (item.OrderType.trim()) {
                        case "Market":
                        case "MarketOnOpen":
                        case "MarketOnClose":
                          ammountString = "Mercado";
                          break;
                        case "Limit":
                          ammountString = "Limit";
                          ammount = item.OrderPrice;
                          break;
                        case "Stop":
                          ammountString = "Stop";
                          ammount = item.OrderStopPrice;
                          break;
                        case "StopLimit":
                          ammountString = "Stop Limit";
                          ammount = item.OrderStopPrice;
                          break;
                        default:
                          break;
                      }
                      description += `@ ${ammountString}`;

                      try {
                        if (+item.CurrentAccount.Precheck.Total !== 0)
                          ammount = +item.CurrentAccount.Precheck.Total;
                      } catch (errror) {
                        console.error(error);
                      }
                      let side = item.OrderSide === "Buy" ? "Compra" : "Venta";
                      if (item.AssetClassForm.trim() === "Mutual Funds") {
                        if (item.OrderSide.trim() === "Buy") {
                          side = "Suscripción";
                        } else {
                          side = item.CurrentAccount.IsFullLiquidation ? "Rescate Total" : "Rescate Parcial";
                        }
                      }

                      if (item.AssetClassForm.trim() === "Repo") {
                        side = item.OrderSide.trim() === "Buy" ? "Reportador " : "Reportado ";
                      }

                      currency = item.OrderSettlementCurrencySymbol;
                      if (item.OrderSettlementCurrencySymbol.trim() === "PYG") {
                        currency = "GS";
                      }

                      return (
                        <Fragment>
                          <tr key={index} className={style.tableRow}>
                            <td>{moment(item.OrderInitDate).format("DD MMM YYYY")}</td>
                            <td>{formString[item.AssetClassForm]}</td>
                            <td>{side}</td>
                            <td>{description}</td>
                            <td>
                              {ammount == 0 ? (
                                "-"
                              ) : (
                                <FormattedNumber
                                  value={ammount}
                                  minimumFractionDigits={
                                    item.AssetClassForm === "Mutual Funds" && currency !== "GS" ? 2 : 0
                                  }
                                  maximumFractionDigits={
                                    item.AssetClassForm === "Mutual Funds" && currency !== "GS" ? 2 : 0
                                  }
                                />
                              )}
                            </td>
                            <td>{currency}</td>
                            <td>
                              <img
                                src={pdf}
                                className={style.icon}
                                alt="pdf-icon"
                                onClick={() => handleDownload(item)}
                              />
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
          </Container>
        </Col>
      </Row>
      {/* <Warning text={texts.notes.orders_note} /> */}
    </Fragment>
  );
};

export default OrdersComponent;
